import React, { useState } from "react";
import { Button, Form, FormListFieldData, Input, Select } from "antd";
import { Gender, Relation_Type } from "../../../../constant/constant";
import NextButton from "../utils/next-button.view";
import { DeleteOutlined } from "@ant-design/icons";
import { IFamilyDetailFormModel } from "./types/family-detail.types";
import PhoneInput from "../../../common/phone-input/phone-input";
import '../../../../styles/component/employee-create.scss';


interface IFamilyDetailViewProps {
    goToNextTab: () => void;
    onSubmit: (values: IFamilyDetailFormModel) => Promise<void>;
    viewModel: IFamilyDetailFormModel;
}


const FamilyDetailView = (props: IFamilyDetailViewProps) => {
    const [familyDetailsForm] = Form.useForm();
    const [valid, setIsValid] = useState<boolean>(true);


    const handleResetFields = (index: number) => {
        const currentFields = familyDetailsForm.getFieldValue("familyDetails");
        const updatedFields = [...currentFields];
        updatedFields[index] = {
            name: "",
            mobileNumber: {
                countryCode: "",
                number: ""
            },
            relationType: "",
            gender: "",
        };
        familyDetailsForm.setFieldsValue({
            familyDetails: updatedFields,
        });
    };

    async function handleFormFinish() {
        await familyDetailsForm.validateFields()
            .then((formValues: IFamilyDetailFormModel) => {
                console.log("Family details form values: ", formValues);
                setIsValid(true);
                props.onSubmit(formValues);
            })
            .catch(() => setIsValid(false));
    }


    return (
        <section className={'hrms__employee-create__form family-details'}>
            <div className={'formHeadings'}>
                <h2>Family Details</h2>
            </div>
            <Form
                layout={'vertical'}
                className={"hrms__experience-section family-details"}
                form={familyDetailsForm}
                variant={'filled'}
                onFinish={handleFormFinish}
                initialValues={props.viewModel}
            >
                <Form.List name="familyDetails">
                    {(fields: FormListFieldData[], {add, remove}) => {
                        console.log(fields, 'fieldss')

                        return (
                            fields.map(({key, name, ...restField}, index) => (
                                <div key={key} className="familyDetailBox">
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'name']}
                                        label="Name"
                                        rules={[
                                            {required: true, message: 'Please enter Name'},
                                            {
                                                validator: (_, value) => {
                                                    if (!value) return Promise.reject();
                                                    if (!isNaN(value)) return Promise.reject("Name should be text.");
                                                    return Promise.resolve();
                                                }
                                            }
                                        ]}
                                    >
                                        <Input placeholder="Enter name"/>
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        name={[name, 'mobileNumber']}
                                        label="Mobile Number"
                                        rules={[
                                            {required: true, message: 'Please enter Mobile Number'},
                                            {
                                                validator: (_, value) => {
                                                    if (!value) return Promise.reject();
                                                    if (isNaN(value.number)) return Promise.reject("Mobile number must be numeric")
                                                    if (value.number.length !== 10) return Promise.reject("Mobile number must be 10 digits");
                                                    return Promise.resolve();
                                                }
                                            }
                                        ]}
                                    >
                                        <PhoneInput
                                            placeholder="Enter mobile number"/>
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        name={[name, 'relationType']}
                                        label="Relationship"
                                        rules={[{required: true, message: 'Please select Relationship'}]}
                                    >
                                        <Select placeholder="Select relationship" showSearch virtual={false}>
                                            {(Object.keys(Relation_Type) as Array<keyof typeof Relation_Type>).map((key) => (
                                                <Select.Option value={key} key={key}>
                                                    {Relation_Type[key]}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        name={[name, 'gender']}
                                        label="Gender"
                                        rules={[{required: true, message: 'Please select Gender'}]}
                                    >
                                        <Select placeholder="Select gender" virtual={false}>
                                            {(Object.keys(Gender) as Array<keyof typeof Gender>).map((key) => (
                                                <Select.Option value={key} key={key}>
                                                    {Gender[key]}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    <div style={{display: "flex", gap: '10px'}}>
                                        <Button onClick={() => handleResetFields(index)}>Reset</Button>
                                        {fields.length > 1 && (
                                            <Button danger onClick={() => remove(name)} icon={<DeleteOutlined/>}>
                                                Remove
                                            </Button>
                                        )}
                                    </div>
                                    {index === fields.length - 1 && (
                                        <div className={"employee-create__actions"}>
                                            <Button onClick={() => add()}>Add Family details</Button>
                                        </div>
                                    )}
                                </div>
                            ))
                        )
                    }}
                </Form.List>
            </Form>
            <div className={'saveAndNextButton'}>
                <Button
                    type="primary"
                    htmlType="submit"
                    onClick={handleFormFinish}
                >
                    Submit
                </Button>
                <NextButton
                    goToNextTab={props.goToNextTab}
                    disabled={valid}
                />
            </div>
        </section>
    )
}

export default FamilyDetailView;
